import cn from 'clsx'

// Components
import { Image, Link, Section } from '@tracklib/kit'

// Hooks
import { useDarkMode } from 'modules/profile/hooks'

import styles from './linkimagerowblock.css'

type LinkImageRowProps = {
  value: {
    images: Array<{
      url: string
      image: number
      image_dark_mode?: number
      alt: string
    }>
    dark?: boolean
  }
}

const LinkImageRow = ({ value: { images, dark } }: LinkImageRowProps): JSX.Element => {
  const isDarkMode = useDarkMode()
  return (
    <Section extraPad className={cn(dark && styles.darkWrapper)} contentClassName={cn(dark && styles.darkContent)}>
      <div className={styles.wrapper}>
        {images?.map(({ image, image_dark_mode, url, alt }, i) => (
          <Link href={url} target="_blank" rel="noopener noreferrer" key={String(i)} className={styles.linkImage} aria-label={alt}>
            <span className={styles.imageOuter}>
              <Image
                image={isDarkMode && image_dark_mode ? image_dark_mode : image}
                className={styles.image}
                alt={alt}
                imageWidths={[170, 340, 450, 640]}
                png
              />
            </span>
          </Link>
        ))}
      </div>
    </Section>
  )
}

export default LinkImageRow
